module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-steps"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Steps")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-steps', {
    attrs: {
      "active": _vm.active,
      "icon": "certificate",
      "icon-class": "steps-success",
      "title": "等待商家发货",
      "description": "等待商家发货等待商家发货等待商家发货等待商家发货等待商家发货"
    }
  }, [_c('zan-step', [_vm._v("买家下单")]), _vm._v(" "), _c('zan-step', [_vm._v("商家接单")]), _vm._v(" "), _c('zan-step', [_vm._v("买家提货")]), _vm._v(" "), _c('zan-step', [_vm._v("交易完成")])], 1), _vm._v(" "), _c('zan-button', {
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("只显示步骤条")]), _vm._v(" "), _c('zan-steps', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('zan-step', [_vm._v("买家下单")]), _vm._v(" "), _c('zan-step', [_vm._v("商家接单")]), _vm._v(" "), _c('zan-step', [_vm._v("买家提货")]), _vm._v(" "), _c('zan-step', [_vm._v("交易完成")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dd155bc!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/steps.vue
// module id = 287
// module chunks = 0